<div class="login_container">
  <div class="center">
    <h1>Reset your password!</h1>
    <p>Which email address did you use for registration?</p>

    <form #loginForm="ngForm">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Email Address</mat-label>
          <input matInput placeholder=""
                 name="email"
                 required
                 type="email"
                 [(ngModel)]="email">
          <mat-error>
            Must be a valid email address!
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <button mat-raised-button (click)="forgotPassword()"
                [disabled]="!loginForm.valid" color="primary"
                class="smarticle_text_btn" cdkFocusInitial>Send</button>
      </div>
    </form>
  </div>
</div>
